import axios from "axios";

/**
 * Obtiene la información general de un curso
 * @param {string} courseId ID del curso.
 * @return {Object} Información general del curso.
 */
export async function getCourse(courseId) {
  return axios
    .get(`${import.meta.env.VITE_API_BASE_URL}/api/modules/${courseId}`)
    .then((response) => response.data)
    .catch((err) => {
      console.error(err);
      throw err;
    });
}

/**
 * Inscribe a un estudiante en un curso.
 * @param {string} userId ID del estudiante.
 * @param {string} courseId ID del curso.
 * @return {Object} Respuesta.
 */
export async function enrollToCourse(courseId) {
  return axios
    .post(`${import.meta.env.VITE_API_BASE_URL}/api/modules/enroll`, {
      course: courseId,
    })
    .then((response) => response.data)
    .catch((err) => console.error(err));
}

/**
 * Habilita la sombra para un módulo.
 * @param {string} moduleId ID del módulo.
 * @return {Promise} Promesa con la respuesta de la solicitud.
 */
export async function enableShadow(moduleId) {
  return axios.post(
    `${import.meta.env.VITE_API_BASE_URL}/api/modules/enableShadow/${moduleId}`,
    { moduleId }
  );
}

/**
 * Deshabilita la sombra para un módulo.
 * @param {string} moduleId ID del módulo.
 * @return {Promise} Promesa con la respuesta de la solicitud.
 */
export async function disableShadow(moduleId) {
  return axios.post(
    `${import.meta.env.VITE_API_BASE_URL}/api/modules/disableShadow/${moduleId}`,
    { moduleId }
  );
}